import { InjectionToken } from '@angular/core';

export type Language = 'fr' | 'en' | 'wo';

export interface UiConfiguration {
  defaultLanguage: Language;
  multiLanguageEnabled: boolean;
}

export const uiConfiguration: UiConfiguration = {
  defaultLanguage: 'fr',
  multiLanguageEnabled: false,
};

export const UI_CONFIGURATION = new InjectionToken<UiConfiguration>('UI_CONFIGURATION', {
  providedIn: 'root',
  factory: () => uiConfiguration,
});
